import { Alerts } from "../../../../../../utils/Alerts.js";
import { useRPCContext } from "../../../../../../contexts/RPCContext.js";
import { UserName } from "../../../../../Users/shared/UserName.js";
import { FormBuilderFormRenderer } from "../../../../../FormBuilder/components/FormBuilderFormRenderer/index.js";
import { useState } from "react";
import { Constants, FormLayout, Loading, useContainerDimensionsContext } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/Events/shared/EventInteractive/EventDispositionFormBuilder/components/FormBuilderInput.tsx
function EventDispositionFormBuilderInput({ assignedUserId, event, eventType, onCancel, onComplete }) {
	const [formInput, setFormInput] = useState(event.dispositionFormInputByAssignedUserId?.[assignedUserId]);
	const [saving, setSaving] = useState(false);
	const { rpcService } = useRPCContext();
	const { viewport: { width: viewportWidth } } = useContainerDimensionsContext();
	const isMobileLayout = viewportWidth < Constants.Breakpoint.Sm.width;
	const formId = event.dispositionFormInputByAssignedUserId?.[assignedUserId]?.formId || eventType.formsConfig.dispositionFormId;
	const handleSave = () => {
		if (!formInput) throw new Error("No form input");
		setSaving(true);
		rpcService.Events.SaveEventDisposition.v1.call({
			assignedUserId,
			dispositionFormInput: formInput,
			eventId: event.id
		}).then(() => {
			Alerts.success("Event disposition updated");
			onComplete();
		}).catch((err) => {
			console.log("Events.UpdateEvent.v1.call() err", err);
			Alerts.error("There was a problem updating the Event disposition", err.message);
		}).finally(() => setSaving(false));
	};
	if (!formId) return /* @__PURE__ */ jsx("div", { children: "No Form" });
	return /* @__PURE__ */ jsxs("div", {
		className: "relative",
		children: [saving && /* @__PURE__ */ jsx(Loading, { overlay: true }), /* @__PURE__ */ jsxs(FormLayout, {
			horizontal: false,
			heading: /* @__PURE__ */ jsxs("div", { children: ["Disposition - ", /* @__PURE__ */ jsx(UserName, { userId: assignedUserId })] }),
			children: [/* @__PURE__ */ jsx(FormBuilderFormRenderer, {
				formId,
				initialValue: formInput?.fields,
				onFormInputChange: setFormInput
			}), /* @__PURE__ */ jsx(FormLayout.Controls, {
				isHorizontal: !isMobileLayout,
				disabled: saving,
				onCancel,
				onSave: handleSave,
				submitLabel: "Save"
			})]
		})]
	});
}
//#endregion
export { EventDispositionFormBuilderInput };

//# sourceMappingURL=FormBuilderInput.js.map